// extracted by mini-css-extract-plugin
module.exports = {"container":"EditProject_container__22fI0"};